// extracted by mini-css-extract-plugin
module.exports = {"circle":"sc","a":"sd"};